<template>
  <div class="search_bar_desktop leaderboardview">
    <div class="input-group search_map_desktop">
      <span class="input-group-addon map_addon_desktop" id="search-addon-map-desktop"><i class="icon-search"></i></span>
      <input ref="leadersearch" id="leadersearch" v-model="searchTerm" type="text" class="form-control search_map_desktop" placeholder="Search for an athlete" aria-describedby="search-addon-map-desktop">
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
      searchTerm: ''
    }
  },
  created () {
    this.searchTerm = this.search
  },
//  beforeRouteEnter (to, from, next) {
//    next(vm => {
//      if (to.name === 'leaderboard' && from.name === 'map') {
//        vm.$refs.leadersearch.focus()
//      }
//    })
//  },
  computed: {
    ...mapGetters({
      search: 'search'
    })
  },
  watch: {
    searchTerm: function () {
      this.$store.dispatch('loadSearch', this.searchTerm)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search.vue